'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagBiAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 3.33786e-06H28C27.9998 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 0 6.66667 0 3.33786e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 3.33786e-06H28L28 20H0V3.33786e-06Z", fill: "#E4233B" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 3.33786e-06L12 10L0 20V3.33786e-06Z",
          fill: "#34CD4E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28 3.33786e-06L16 10L28 20L28 3.33786e-06Z",
          fill: "#34CD4E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.9621 6.39375C16.1563 5.73116 15.1246 5.33334 14 5.33334C12.8754 5.33334 11.8437 5.73116 11.0379 6.39375L1.50003 0L0 3.33786e-06L3.14713e-05 2L9.54576 8.60387C9.40773 9.0447 9.33333 9.51366 9.33333 10C9.33333 10.4863 9.40773 10.9553 9.54576 11.3961L1.66893e-06 18L0 20L1.5 20L11.0379 13.6063C11.8437 14.2688 12.8754 14.6667 14 14.6667C15.1246 14.6667 16.1563 14.2688 16.9621 13.6063L26.5 20L28 20L28 18L18.4542 11.3961C18.5923 10.9553 18.6667 10.4863 18.6667 10C18.6667 9.51366 18.5923 9.0447 18.4542 8.60387L28 2L28 3.33786e-06L26.5 0L16.9621 6.39375Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.9998 8.66669L13.057 8.94283L13.3332 8.00002L13.057 7.05721L13.9998 7.33336L14.9426 7.05721L14.6665 8.00002L14.9426 8.94283L13.9998 8.66669Z",
          fill: "#DF2239"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.9998 12L11.057 12.2761L11.3332 11.3333L11.057 10.3905L11.9998 10.6667L12.9426 10.3905L12.6665 11.3333L12.9426 12.2761L11.9998 12Z",
          fill: "#DF2239"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.057 12.2761L15.9998 12L16.9426 12.2761L16.6665 11.3333L16.9426 10.3905L15.9998 10.6667L15.057 10.3905L15.3332 11.3333L15.057 12.2761Z",
          fill: "#DF2239"
        }
      )
    ]
  }
);
const VpFlagBiAsset = forwardRef(FlagBiAsset);

export { VpFlagBiAsset as default };
